export default __webpack_public_path__ + "static/media/assembly_1.fb8e78be.png";